module.exports = __webpack_public_path__ + "img/apple-icon-76x76.7d957b97.png";